<template>
  <div>
    <header class="topbar">
      <div>
        <div class="topTitle">{{ pageTitle }}</div>
      </div>
      <div class="topRight">
        <!-- <div class="pill">{{ statsSummary }}</div> -->
        <!-- <button type="button" @click="onCreateInterview">+ 添加面试</button> -->
      </div>
    </header>

    <CommonFilterTableCard
      title="🧾 面试复核"
      :items="allInterviews"
      :page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      empty-text="暂无复核数据"
      :columns="reviewColumns"
      :loading="tableLoading"
      :use-server-pagination="true"
      :total="reviewTotal"
      :filter-schema="reviewFilterSchema"
      :filter-values.sync="reviewFilters"
      @page-change="fetchReviewList"
      @filter-change="onReviewFilterChange"
    >
      <template #col-candidate="{ row }">
        <a href="javascript:void(0)" class="candidate-link" @click.prevent="goInterviewDetail(row)">
          {{ row.candidate_name || "—" }}
        </a>
      </template>

      <template #col-candidate_email="{ row }">
        {{ row.candidate_email || "—" }}
      </template>

      <template #col-interviewer_name="{ row }">
        {{ (row.interviewer_info && row.interviewer_info.name) || "—" }}
      </template>

      <template #col-interviewer_phone="{ row }">
        {{ (row.interviewer_info && row.interviewer_info.phone) || "—" }}
      </template>

      <template #col-interviewer_email="{ row }">
        {{ (row.interviewer_info && row.interviewer_info.email) || "—" }}
      </template>

      <template #col-recruiter_name="{ row }">
        {{ (row.recruiter_info && row.recruiter_info.name) || "—" }}
      </template>

      <template #col-recruiter_phone="{ row }">
        {{ (row.recruiter_info && row.recruiter_info.phone) || "—" }}
      </template>

      <template #col-evaluation_result="{ row }">
        <span :class="['status', 'review-status-tag', 'review-status-tag--center', evaluationOutcomeClass(row)]">
          {{ Number(row.evaluation_result) === 1 ? "通过" : Number(row.evaluation_result) === 0 ? "淘汰" : "—" }}
        </span>
      </template>

      <template #col-review_conclusion="{ row }">
        <span :class="['status', 'review-status-tag', 'review-status-tag--fixed-4ch', reviewOutcomeClass(row)]">
          {{ reviewStatusLabelMap[Number(row.current_status)] || "—" }}
        </span>
      </template>

      <template #col-pde_report_url="{ row }">
        <span
          v-if="reportPdfReady(row)"
          style="display: flex; align-items: center; gap: 8px; justify-content: center; flex-wrap: wrap"
        >
          <el-button size="small" native-type="button" class="btnLink primary small" @click="previewReport(row)">预览</el-button>
          <el-button size="small" native-type="button" class="btnLink primary small" @click="downloadReport(row)">下载</el-button>
        </span>
        <span v-else-if="reportPdfFailed(row)" class="status bad review-status-tag review-status-tag--fixed-4ch">生成失败</span>
        <span v-else-if="Number(row.pdf_report_status) === 0" class="status warn review-status-tag review-status-tag--fixed-4ch">生成中</span>
        <span v-else ></span>
      </template>

      <template #col-actions="{ row }">
        <span style="display: inline-flex; align-items: center; gap: 8px;">
          <el-button
            v-if="reportPdfFailed(row)"
            v-has="'btn_afresh'"
            class="btnLink primary small"
            @click="regenerateReviewReport(row && row.id)"
          >
            重新生成
          </el-button>
          <el-button
            v-if="Number(row.current_status) === 4"
            class="btnLink primary small"
            :disabled="reviewDisabled(row)"
            @click="goReview(row)"
          >
            复核
          </el-button>
          <el-button
            v-if="Number(row.current_status) === 5 || Number(row.current_status) === 6"
            class="btnLink primary small"
            @click="goReviewView(row)"
          >
            查看
          </el-button>
          <el-button
            v-if="reportPdfReady(row)"
            v-has="'btn_push'"
            class="btnLink primary small"
            @click="handlePushReport(row)"
          >
            推送报告
          </el-button>
        </span>
      </template>
    </CommonFilterTableCard>

    <!-- 面试评估报告预览弹窗 -->
    <div v-if="showPreviewModal" class="modal-overlay preview-modal">
      <div class="modal-content">
        <div class="preview-header">
          <h3>面试评估报告预览</h3>
          <el-button size="small" native-type="button" class="preview-close-btn" @click="closePreviewModal">&times;</el-button>
        </div>
        <div class="preview-body">
          <div v-if="previewLoading" class="preview-loading">
            <span class="preview-loading-spinner" />
            <span>正在获取预览数据…</span>
          </div>
          <InterviewAssessmentReportPreview v-else-if="previewReportData" :report-data="previewReportData" />
          <div v-else class="preview-empty">暂无可预览的报告数据</div>
        </div>
        <div class="preview-footer">
          <el-button size="small" native-type="button" @click="closePreviewModal">关闭</el-button>
        </div>
      </div>
    </div>

    <div v-if="downloadReportData" class="pdf-export-renderer" aria-hidden="true">
      <InterviewAssessmentReportPreview ref="downloadReportRef" :report-data="downloadReportData" />
    </div>

    <div v-if="downloadingReport" class="download-loading-mask" aria-live="polite" aria-busy="true">
      <div class="download-loading-card">
        <span class="download-loading-spinner" />
        <span class="download-loading-text">下载中...</span>
      </div>
    </div>
  </div>
</template>

<script>
import CommonFilterTableCard from "../components/CommonFilterTableCard.vue";
import { listInterviewReview, regenerateInterviewReport, getInterviewReportData, pushReportToOa } from "@/api/modules/interview/interview";
import html2pdf from "html2pdf.js";
import InterviewAssessmentReportPreview from "../components/InterviewAssessmentReportPreview.vue";
import mockReportResponse from "../components/response_1776149838364.json";

// 预览数据开关：本地调样式时可改为 true 使用 mock
const USE_MOCK_PREVIEW_REPORT = false;

export default {
  name: "InterviewerReviewPage",
  components: { CommonFilterTableCard, InterviewAssessmentReportPreview },
  data() {
    return {
      reviewFilters: {
        status: "all",
        candidate_param: "",
        interviewer_param: "",
        position: "",
        recruiter_param: "",
        evaluation_result: "",
      },
      page: { pageNo: 1, pageSize: 10 },
      tableLoading: false,
      allInterviews: [],
      reviewTotal: 0,
      showPreviewModal: false,
      previewLoading: false,
      previewReportData: null,
      downloadReportData: null,
      downloadingReport: false,
      // review_conclusion 显示文案映射（按 current_status 0-6）
      reviewStatusLabelMap: {
        0: "待通知",
        1: "待开始",
        2: "进行中",
        3: "待评价",
        4: "待复核",
        5: "复核淘汰",
        6: "复核通过",
      },
    };
  },
  computed: {
    pageTitle() {
      return (this.$route.meta && this.$route.meta.title) || "面试复核";
    },
    pageSub() {
      return (this.$route.meta && this.$route.meta.subTitle) || "";
    },
    reviewColumns() {
      return [
        { label: "候选人", slot: "candidate", minWidth: 90 },
        { label: "候选人电话", prop: "candidate_phone", minWidth: 120 },
        { label: "候选人邮箱", slot: "candidate_email", minWidth: 160 },
        { label: "面试官", slot: "interviewer_name", minWidth: 90 },
        { label: "面试官电话", slot: "interviewer_phone", minWidth: 120 },
        { label: "面试官邮箱", slot: "interviewer_email", minWidth: 160 },
        { label: "应聘岗位", prop: "position", minWidth: 90 },
        { label: "招聘HR", slot: "recruiter_name", minWidth: 90 },
        { label: "HR电话", slot: "recruiter_phone", minWidth: 120 },
        { label: "面试结果", slot: "evaluation_result", minWidth: 90, align: "center" },
        { label: "复核结果", slot: "review_conclusion", minWidth: 90, align: "center" },
        { label: "面试评估报告", slot: "pde_report_url", minWidth: 160, align: "center" },
        { label: "操作", slot: "actions", minWidth: 160, fixed: "right" },
      ];
    },
    statsSummary() {
      const pendingNotify = this.allInterviews.filter((iv) => Number(iv.current_status) === 0).length;
      const pending = this.allInterviews.filter((iv) => Number(iv.current_status) === 1).length;
      const ongoing = this.allInterviews.filter((iv) => Number(iv.current_status) === 2).length;
      const pendingEval = this.allInterviews.filter((iv) => Number(iv.current_status) === 3).length;
      return `📊 待通知:${pendingNotify} 待开始:${pending} 进行中:${ongoing} 待评价:${pendingEval}`;
    },
    reviewFilterSchema() {
      return [
        {
          label: "复核状态",
          field: "status",
          type: "select",
          options: [
            { label: "全部", value: "all" },
            { label: "待复核", value: "4" },
            { label: "已复核", value: "5" },
          ],
        },
        {
          label: "候选人姓名/电话",
          field: "candidate_param",
          type: "input",
          placeholder: "请输入",
        },
        {
          label: "面试官姓名/电话",
          field: "interviewer_param",
          type: "input",
          placeholder: "请输入",
        },
        {
          label: "面试岗位",
          field: "position",
          type: "input",
          placeholder: "请输入",
        },
        {
          label: "招聘HR/电话",
          field: "recruiter_param",
          type: "input",
          placeholder: "请输入",
        },
        {
          label: "面试结果",
          field: "evaluation_result",
          type: "select",
          options: [
            { label: "全部", value: "" },
            { label: "通过", value: "1" },
            { label: "淘汰", value: "0" },
          ],
        },
      ];
    },
  },
  methods: {
    onCreateInterview() {
      this.$router.push({ name: "interviewer-dashboard-schedule" });
    },
    goInterviewDetail(row) {
      const resumeRaw = row && row.resume;
      const resume = typeof resumeRaw === "object" ? JSON.stringify(resumeRaw || {}) : resumeRaw || "";
      this.$router.push({
        name: "interviewDetail",
        query: {
          from: this.$route.name || "interviewer-dashboard-review",
          id: (row && row.id) || "",
          interview_time: (row && row.interview_time) || "",
          candidate_name: (row && row.candidate_name) || "",
          candidate_phone: (row && row.candidate_phone) || "",
          candidate_email: (row && row.candidate_email) || "",
          interviewer_name: (row && row.interviewer_info && row.interviewer_info.name) || "",
          interviewer_phone: (row && row.interviewer_info && row.interviewer_info.phone) || "",
          interviewer_email: (row && row.interviewer_info && row.interviewer_info.email) || "",
          position: (row && row.position) || "",
          recruiter_name: (row && row.recruiter_info && row.recruiter_info.name) || "",
          recruiter_phone: (row && row.recruiter_info && row.recruiter_info.phone) || "",
          current_status: row && row.current_status != null ? String(row.current_status) : "",
          resume,
        },
      });
    },
    async fetchReviewList(pageNum) {
      this.tableLoading = true;
      try {
        if (pageNum != null) {
          this.page.pageNo = parseInt(pageNum, 10) || 1;
        }
        // pageSize 在分页组件里不会改变，但按你的要求也放在 page 对象里统一维护
        this.page.pageSize = parseInt(this.page.pageSize, 10) || 10;
        const statusVal = this.reviewFilters && this.reviewFilters.status;
        const current_status =
          !statusVal || statusVal === "all" ? 0 : parseInt(statusVal, 10);

        // 面试结果：后端入参字段通常与列表字段保持一致（evaluation_result: 0/1）
        const evaluationResultVal = this.reviewFilters && this.reviewFilters.evaluation_result;
        const evaluation_result =
          evaluationResultVal === "" || evaluationResultVal == null
            ? undefined
            : parseInt(evaluationResultVal, 10);
        const candidate_param = String(
          (this.reviewFilters && this.reviewFilters.candidate_param) || ""
        ).trim();
        const interviewer_param = String(
          (this.reviewFilters && this.reviewFilters.interviewer_param) || ""
        ).trim();
        const position = String((this.reviewFilters && this.reviewFilters.position) || "").trim();
        const recruiter_param = String(
          (this.reviewFilters && this.reviewFilters.recruiter_param) || ""
        ).trim();
        const params = {
          page_num: this.page.pageNo,
          page_size: this.page.pageSize,
          candidate_param,
          interviewer_param,
          position,
          recruiter_param,
          current_status,
        };
        if (evaluation_result !== undefined && !Number.isNaN(evaluation_result)) {
          params.evaluation_result = evaluation_result;
        }
        const res = await listInterviewReview(params);
        const rows = res && Array.isArray(res.rows) ? res.rows : [];
        this.reviewTotal = res.total;
        this.allInterviews = rows;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("fetchReviewList failed:", e);
        this.allInterviews = [];
        this.reviewTotal = 0;
      } finally {
        this.tableLoading = false;
      }
    },
    onReviewFilterChange() {
      this.page.pageNo = 1;
      this.page.pageSize = parseInt(this.page.pageSize, 10) || 10;
      this.fetchReviewList(1);
    },
    evaluationOutcomeClass(iv) {
      const n = Number(iv && iv.evaluation_result);
      if (n === 1) return "ok";
      if (n === 0) return "bad";
      return "gray";
    },
    reviewOutcomeClass(iv) {
      const n = Number(iv && iv.current_status);
      if (n === 6) return "ok";
      if (n === 5) return "bad";
      if (n === 4) return "warn";
      return "gray";
    },
    getReviewOutcomeLabel(row) {
      const explicitTextFields = [
        row && row.review_conclusion_label,
        row && row.review_conclusion_name,
        row && row.review_conclusion_text,
      ];
      const explicitText = explicitTextFields.find((v) => typeof v === "string" && v.trim());
      if (explicitText) return explicitText.trim();

      const currentStatus = Number(row && row.current_status);
      if ([5, 6].includes(currentStatus)) {
        return this.reviewStatusLabelMap[currentStatus] || "";
      }

      const reviewConclusion = Number(row && row.review_conclusion);
      if (reviewConclusion === 1) return "复核通过";
      if (reviewConclusion === 0 || reviewConclusion === 2) return "复核淘汰";
      return "";
    },
    isReviewedOutcome(row) {
      const label = this.getReviewOutcomeLabel(row);
      return label === "复核通过" || label === "复核淘汰";
    },
    /** pdf_report_status：1 已生成且需 pde_report_url；旧数据无该字段时仅有 url 也视为可复核 */
    reportPdfReady(row) {
      // const url = row && row.pde_report_url;
      // if (!url) return false;
      const st = row.pdf_report_status;
      // if (st === undefined || st === null || st === "") {
      //   return true;
      // }
      return Number(st) === 1;
    },
    reportPdfFailed(row) {
      return Number(row && row.pdf_report_status) === 2;
    },
    reviewDisabled(row) {
      const st = Number(row && row.pdf_report_status);
      return st === 0 || st === 2;
    },
    goReview(iv) {
      const currentStatus = Number(iv && iv.current_status);

      if (![4, 5, 6].includes(currentStatus)) {
        this.$message.warning("当前状态无法进入复核");
        return;
      }

      if (this.reportPdfFailed(iv)) {
        this.$message.warning("评估报告生成失败，请先点击‘重新生成’后再进行复核");
        return;
      }

      if (!this.reportPdfReady(iv)) {
        const st = Number(iv && iv.pdf_report_status);
        if (st === 0) this.$message.info("评估报告未生成，待生成完成后再进行复核");
        else this.$message.info("评估报告生成中，待生成完成后再进行复核");
        return;
      }

      this.$router.push({
        path: "/review",
        query: {
          id: iv.id,
          candidate_name: iv.candidate_name ?? "",
          position: iv.position,
          mode: "edit",
          review_conclusion: iv && iv.review_conclusion != null ? String(iv.review_conclusion) : "",
          review_remarks: (iv && iv.review_remarks) || "",
        },
      });
    },
    goReviewView(iv) {
      this.$router.push({
        path: "/review",
        query: {
          id: iv.id,
          candidate_name: iv.candidate_name ?? "",
          position: iv.position,
          mode: "view",
          review_conclusion: iv && iv.review_conclusion != null ? String(iv.review_conclusion) : "",
          review_remarks: (iv && iv.review_remarks) || "",
        },
      });
    },

    async regenerateReviewReport(interviewId) {
      if (!interviewId) {
        this.$message.warning("缺少面试 ID，无法重新生成");
        return;
      }
      try {
        await regenerateInterviewReport(interviewId);
        this.$message.success("重新生成成功");
        this.fetchReviewList(this.page.pageNo);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("regenerateReviewReport failed:", e);
        // this.$message.warning("重新生成失败，请稍后重试");
      }
    },
    async handlePushReport(row) {
      if (!row || !row.id) {
        this.$message.warning("缺少面试 ID，无法推送");
        return;
      }
      try {
        await this.$confirm("确定要推送该面试评估报告到 OA 吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        await pushReportToOa(row.id);
        this.$message.success("推送成功");
        this.fetchReviewList(this.page.pageNo);
      } catch (e) {
        // $confirm 取消时会抛出异常，需区分
        if (e !== "cancel" && e !== "close") {
          // eslint-disable-next-line no-console
          console.error("pushReportToOa failed:", e);
        }
      }
    },
    buildReportDownloadName(iv) {
      const candidateName = String((iv && iv.candidate_name) || "").trim() || "候选人";
      const interviewId = String((iv && iv.id) || "").trim() || "unknown";
      const now = new Date();
      const yyyy = String(now.getFullYear());
      const MM = String(now.getMonth() + 1).padStart(2, "0");
      const dd = String(now.getDate()).padStart(2, "0");
      const HH = String(now.getHours()).padStart(2, "0");
      const mm = String(now.getMinutes()).padStart(2, "0");
      const ss = String(now.getSeconds()).padStart(2, "0");
      const timestamp = `${yyyy}${MM}${dd}${HH}${mm}${ss}`;
      return `${candidateName}面试评估报告_${interviewId}_${timestamp}.pdf`;
    },
    async getReportDataForExport(interviewId) {
      const res = await getInterviewReportData(interviewId);
      return res && res.data ? res.data : null;
    },
    wait(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async ensureExportAssetsReady(sourceEl) {
      if (!sourceEl) return;

      // 等待组件一次额外渲染，避免慢机上刚 nextTick 就开始截图导致内容缺失
      await this.$nextTick();
      await this.wait(120);

      const images = Array.from(sourceEl.querySelectorAll("img"));
      if (images.length) {
        await Promise.all(
          images.map(
            (img) =>
              new Promise((resolve) => {
                if (img.complete) {
                  resolve();
                  return;
                }
                const done = () => {
                  img.removeEventListener("load", done);
                  img.removeEventListener("error", done);
                  resolve();
                };
                img.addEventListener("load", done);
                img.addEventListener("error", done);
              })
          )
        );
      }

      if (document.fonts && document.fonts.ready) {
        try {
          await document.fonts.ready;
        } catch (e) {
          // eslint-disable-next-line no-console
          console.warn("wait document.fonts.ready failed:", e);
        }
      }
    },
    getAdaptivePdfScale(sourceEl, preferredScale = 2) {
      if (!sourceEl) return preferredScale;

      const rect = sourceEl.getBoundingClientRect();
      const width = Math.max(rect.width || sourceEl.scrollWidth || 0, 1);
      const height = Math.max(sourceEl.scrollHeight || rect.height || 0, 1);

      // 不同设备/GPU/浏览器对 canvas 最大尺寸支持存在差异；保守上限更稳定。
      const maxCanvasDimension = 16384;
      const scaleByWidth = maxCanvasDimension / width;
      const scaleByHeight = maxCanvasDimension / height;
      const safeScale = Math.min(preferredScale, scaleByWidth, scaleByHeight);

      // 最低保持 1，优先保证不截断，其次再追求清晰度。
      return Math.max(1, Number(safeScale.toFixed(2)));
    },
    async renderElementToCanvas(sourceEl, scale) {
      const worker = html2pdf()
        .set({
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: {
            scale,
            useCORS: true,
            backgroundColor: "#ffffff",
            windowWidth: Math.ceil(sourceEl.scrollWidth || sourceEl.clientWidth || 920),
            windowHeight: Math.ceil(sourceEl.scrollHeight || sourceEl.clientHeight || 1200),
            scrollX: 0,
            scrollY: 0,
          },
        })
        .from(sourceEl)
        .toCanvas();
      await worker;
      const canvas = await worker.get("canvas");
      if (!canvas || !canvas.width || !canvas.height) {
        throw new Error("渲染失败：未生成有效画布");
      }
      return canvas;
    },
    async createEmptyPdfDoc() {
      const seedCanvas = document.createElement("canvas");
      seedCanvas.width = 10;
      seedCanvas.height = 10;
      const seedCtx = seedCanvas.getContext("2d");
      if (seedCtx) {
        seedCtx.fillStyle = "#ffffff";
        seedCtx.fillRect(0, 0, seedCanvas.width, seedCanvas.height);
      }

      const worker = html2pdf()
        .set({
          margin: [0, 0, 0, 0],
          image: { type: "jpeg", quality: 0.98 },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        })
        .from(seedCanvas)
        .toPdf();
      await worker;
      const pdf = await worker.get("pdf");
      return pdf;
    },
    ensurePdfHasPage(pdf) {
      if (!pdf || !pdf.internal || typeof pdf.internal.getNumberOfPages !== "function") return;
      if (pdf.internal.getNumberOfPages() === 0) {
        pdf.addPage();
      }
    },
    appendCanvasToPdf(pdf, canvas, options) {
      if (!pdf || !canvas) return options && options.currentY ? options.currentY : options.marginTop;

      const marginTop = options.marginTop;
      const marginRight = options.marginRight;
      const marginBottom = options.marginBottom;
      const marginLeft = options.marginLeft;
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const contentWidth = pageWidth - marginLeft - marginRight;
      const contentHeight = pageHeight - marginTop - marginBottom;

      let currentY = options.currentY;
      const imageType = "JPEG";
      const quality = 0.98;

      this.ensurePdfHasPage(pdf);

      const pxPerMm = canvas.width / contentWidth;
      if (!Number.isFinite(pxPerMm) || pxPerMm <= 0) {
        throw new Error("分页失败：画布宽度异常");
      }
      const blockHeightMm = canvas.height / pxPerMm;
      const availableMm = pageHeight - marginBottom - currentY;

      // 常规区块：若放不下则整块推到下一页，避免在分页边界被切断。
      if (blockHeightMm <= contentHeight && blockHeightMm > availableMm + 0.01) {
        pdf.addPage();
        currentY = marginTop;
      }

      // 能整块放下时直接写入，不做切片。
      if (blockHeightMm <= contentHeight) {
        const imgDataWhole = canvas.toDataURL("image/jpeg", quality);
        pdf.addImage(imgDataWhole, imageType, marginLeft, currentY, contentWidth, blockHeightMm);
        return currentY + blockHeightMm;
      }

      const pageSlicePx = Math.max(1, Math.floor(contentHeight * pxPerMm));
      let offsetPx = 0;

      while (offsetPx < canvas.height) {
        const remainPx = canvas.height - offsetPx;
        const slicePx = Math.min(pageSlicePx, remainPx);
        const sliceMm = slicePx / pxPerMm;

        if (currentY + sliceMm > pageHeight - marginBottom + 0.01) {
          pdf.addPage();
          currentY = marginTop;
        }

        const sliceCanvas = document.createElement("canvas");
        sliceCanvas.width = canvas.width;
        sliceCanvas.height = slicePx;
        const sliceCtx = sliceCanvas.getContext("2d");
        if (!sliceCtx) break;
        sliceCtx.fillStyle = "#ffffff";
        sliceCtx.fillRect(0, 0, sliceCanvas.width, sliceCanvas.height);
        sliceCtx.drawImage(
          canvas,
          0,
          offsetPx,
          canvas.width,
          slicePx,
          0,
          0,
          sliceCanvas.width,
          sliceCanvas.height
        );

        const imgData = sliceCanvas.toDataURL("image/jpeg", quality);
        pdf.addImage(imgData, imageType, marginLeft, currentY, contentWidth, sliceMm);

        offsetPx += slicePx;
        currentY += sliceMm;

        if (offsetPx < canvas.height) {
          pdf.addPage();
          currentY = marginTop;
        }
      }

      return currentY;
    },
    async exportReportBySections(sourceEl, fileName, preferredScale) {
      const reportCard = sourceEl.querySelector(".report-card") || sourceEl;
      const blocks = Array.from(
        reportCard.querySelectorAll(".report-header, .info-strip, .report-sections > .section")
      ).filter(Boolean);
      const exportBlocks = blocks.length ? blocks : [sourceEl];

      const pdf = await this.createEmptyPdfDoc();
      const margins = {
        marginTop: 8,
        marginRight: 8,
        marginBottom: 8,
        marginLeft: 8,
      };
      let currentY = margins.marginTop;

      for (let i = 0; i < exportBlocks.length; i += 1) {
        const blockEl = exportBlocks[i];
        const blockScale = this.getAdaptivePdfScale(blockEl, preferredScale);
        const canvas = await this.renderElementToCanvas(blockEl, blockScale);
        currentY = this.appendCanvasToPdf(pdf, canvas, { ...margins, currentY });
      }

      pdf.save(fileName);
    },
    async previewReport(iv) {
      if (!iv || !iv.id) {
        this.$message.info("缺少面试记录，无法预览");
        return;
      }
      this.previewLoading = true;
      this.previewReportData = null;
      this.showPreviewModal = true;
      try {
        let data = null;
        if (USE_MOCK_PREVIEW_REPORT) {
          data = mockReportResponse && mockReportResponse.data ? mockReportResponse.data : null;
        } else {
          const res = await getInterviewReportData(iv.id);
          data = res && res.data ? res.data : null;
        }
        if (!data) {
          this.$message.warning("预览数据格式不正确");
          this.showPreviewModal = false;
          return;
        }
        this.previewReportData = data;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("previewReport failed:", e);
        this.$message.warning("预览失败");
        this.showPreviewModal = false;
      } finally {
        this.previewLoading = false;
      }
    },
    closePreviewModal() {
      this.showPreviewModal = false;
      this.previewReportData = null;
      this.previewLoading = false;
    },
    async downloadReport(iv) {
      if (!iv || !iv.id) {
        this.$message.info("缺少面试记录，暂时无法下载");
        return;
      }
      if (this.downloadingReport) {
        this.$message.info("正在生成 PDF，请稍候");
        return;
      }

      this.downloadingReport = true;
      try {
        const data = await this.getReportDataForExport(iv.id);
        if (!data) {
          this.$message.warning("下载失败：未获取到报告数据");
          return;
        }
        this.downloadReportData = data;
        await this.$nextTick();

        const reportComp = this.$refs.downloadReportRef;
        const sourceEl = reportComp && reportComp.$el;
        if (!sourceEl) {
          this.$message.warning("下载失败：报告内容尚未就绪");
          return;
        }
        const fileName = this.buildReportDownloadName(iv);
        await this.ensureExportAssetsReady(sourceEl);
        await this.exportReportBySections(sourceEl, fileName, 2);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("downloadReport failed:", e);
        this.$message.warning(`下载失败：${(e && e.message) || "未知错误"}`);
      } finally {
        this.downloadingReport = false;
        this.downloadReportData = null;
      }
    },
  },
  created() {
    this.fetchReviewList(this.page.pageNo);
  },
};
</script>

<style scoped>
.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 8px;
  height: 33px;
}

.topTitle {
  font-size: 18px;
  font-weight: 900;
}

.topSub {
  font-size: 12px;
  color: var(--muted);
  margin-top: 2px;
}

.topRight {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 9px;
  border-radius: 999px;
  border: 1px solid var(--line);
  font-size: 11px;
  color: var(--muted);
  background: #f8fafc;
}

.candidate-link {
  color: var(--brand);
  text-decoration: none;
  cursor: pointer;
}

.candidate-link:hover {
  color: var(--brand);
  opacity: 0.85;
}

/* 列内状态标签：统一做图文垂直居中 */
.review-status-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

/* 面试结果标签保持居中呈现 */
.review-status-tag--center {
  min-width: 40px;
}

/* 复核结果/评估报告状态按“四个汉字”固定宽度 */
.review-status-tag--fixed-4ch {
  width: 64px;
  min-width: 64px;
  max-width: 64px;
  padding: 0;
  gap: 0;
  box-sizing: border-box;
  line-height: 22px;
}

/* 预览模态框样式（从原型页迁移，保持一致） */
.preview-modal .modal-content {
  width: 850px;
  max-width: 98vw;
  max-height: 85vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0;
  background: #ffffff;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid var(--line);
}

.preview-header h3 {
  margin: 0;
  font-size: 18px;
}

.preview-close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 0 8px;
  color: #909399;
}

.preview-body {
  flex: 1;
  overflow-y: auto;
  padding: 0;
  background: #ffffff;
  position: relative;
  min-height: 200px;
}

.preview-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: 50vh;
  font-size: 14px;
  color: var(--muted);
}

.preview-loading-spinner {
  width: 38px;
  height: 38px;
  border: 4px solid #dbeafe;
  border-top-color: #4270f1;
  border-radius: 50%;
  animation: preview-spin 0.8s linear infinite;
}

.preview-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  font-size: 14px;
  color: var(--muted);
}

@keyframes preview-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.preview-footer {
  padding: 12px 16px;
  border-top: 1px solid var(--line);
  text-align: right;
}

.pdf-export-renderer {
  position: fixed;
  left: -10000px;
  top: 0;
  width: 920px;
  z-index: -1;
  background: #ffffff;
}

.download-loading-mask {
  position: fixed;
  inset: 0;
  z-index: 3000;
  background: rgba(15, 23, 42, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
}

.download-loading-card {
  min-width: 160px;
  padding: 18px 22px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.96);
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.18);
}

.download-loading-spinner {
  width: 38px;
  height: 38px;
  border: 4px solid #dbeafe;
  border-top-color: #4270f1;
  border-radius: 50%;
  animation: preview-spin 0.8s linear infinite;
}

.download-loading-text {
  color: var(--muted);
  font-size: 14px;
  line-height: 1;
}

/* disabled 状态：避免 btnLink/primary 把文字仍渲染为高亮色 */
::v-deep .el-button.btnLink.primary.small.is-disabled,
::v-deep .el-button.btnLink.primary.small.is-disabled:hover,
::v-deep .el-button.btnLink.primary.small.is-disabled:focus,
::v-deep .el-button.btnLink.primary.small.is-disabled:active {
  color: #c0c4cc !important;
  cursor: not-allowed !important;
}

/* 书签栏显示时视口高度小于 953px，收紧表格与分页区内边距 */
@media (max-height: 952px) {
  ::v-deep .table-loading-wrap{
    padding: 14px 16px 2px !important;
  }
  ::v-deep .pagination {
    padding: 10px 16px 6px !important;
  }
  ::v-deep .filter-grid {
    gap: 0px 12px !important;
  }
  ::v-deep .search-bar{
    padding: 10px 16px 12px !important;
  }
}
</style>

